import { Pipe, PipeTransform } from "@angular/core";
import { ErrorMessageWithoutTypeService } from "./error-message-without-type.service";

@Pipe({ name: "errorMessageWithoutType" })
export class ErrorMessageWithoutTypePipe implements PipeTransform {
  constructor(
    private errorMessageWithoutTypeService: ErrorMessageWithoutTypeService,
  ) {}

  public transform(error: string) {
    return this.errorMessageWithoutTypeService.messageFor(error);
  }
}
